import { useState, useEffect } from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import breakPoint from '@utils/constants';
import Products from '@components/Products';
import LiveScore from '@components/LiveScore/LiveScore';
import News from '@components/News';
import Video from '@components/Video';
import CategoryBar from '@components/CategoryBar';
import { Layout } from '@components/Layouts/Layout';
import Seo from '@components/Seo';
import CookiePopup from '@components/Features/CookiePopup';
import { useWindowDimensions } from '@hooks/windowDimension';
import useRefreshData from '../hooks/useRefreshData';
import getServerSideData from '../utils/getServerSideData';
import SiteMapping from '../configs/siteMapping';
import getIsUnderMaintenance from '../utils/getUnderMaintenance';

const HomePage = () => {
    const [currentCategory, setCurrentCategory] = useState('Live Score');
    const { underMaintenanceInfo, siteName } = useSiteInfo();
    const { width } = useWindowDimensions();
    // console.log('process.env.APP_ENV', process.env.APP_ENV);
    const getCategories = () => {
        switch (currentCategory) {
        case 'Products':
            return <Products />;
        case 'Live Score':
            return <LiveScore />;
        case 'Video':
            return <Video />;
        case 'News':
            return <News />;
        default:
            return <LiveScore />;
        }
    };

    useEffect(() => {
        if (currentCategory === 'Products' && width > breakPoint.mediumWidth) {
            setCurrentCategory('Live Score');
        }
    }, [currentCategory, width]);

    useRefreshData(underMaintenanceInfo);

    return (
        <>
            <Seo />
            <Layout>
                <CategoryBar
                    handleSelect={setCurrentCategory}
                    isSelected={currentCategory}
                />
                <CookiePopup />
                {siteName !== SiteMapping.taraPlays && (
                    <div className="main__content">
                        {getCategories()}
                    </div>
                )}
            </Layout>
        </>
    );
};

export async function getServerSideProps({ req, locale }) {
    const {
        host,
        apiHost,
        serverResponseJson,
        headers,
        clientApiUrl,
        serverResponseStatus,
        ip,
        serverIp,
        envConfig,
    } = await getServerSideData({ req });
    if(!serverResponseStatus){
        return {
            redirect: {
                permanent: false,
                destination: `/${locale}/errorPage?ip=${encodeURIComponent(ip)}`,
            },
        };
    }

    if (serverResponseJson?.isDeniedIp) {
        return {
            redirect: {
                permanent: false,
                destination: `/${locale}/accessDenied`,
            },
        };
    }
    if (getIsUnderMaintenance(serverResponseJson.underMaintenanceInfo)) {
        return {
            redirect: {
                permanent: false,
                destination: `/${locale}/underMaintenance`,
            },
        };
    }

    return {
        props: {
            ...(await serverSideTranslations(locale, ['common'])),
            ...serverResponseJson,
            host,
            apiHost,
            ip,
            serverResponseJson,
            headers,
            locale,
            clientApiUrl,
            serverIp,
            envConfig,
        },
    };
}

export default HomePage;
